import React, { Component } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Menu,
  Message,
  Modal,
  List,
  Loader,
  Segment,
  Statistic
} from "semantic-ui-react";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import update from "immutability-helper";
import moment from "moment";
import MaskedInput from "react-text-mask";
import numeral from "numeral";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import CoopPrestamosDetalleView from "./CoopPrestamosDetalleView";

const numberMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  requireDecimal: true,
  allowNegative: true
});

const INITIAL_STATE = {
  prestamos: {
    loading: false,
    records: [],
    error: null
  },
  prestamosUpsertModal: {
    open: false,
    loading: false,
    values: {
      id: null,
      tipo: "PRESTAMO",
      concepto: "",
      monto: 0.0,
      nroCuotas: 6,
      generacionAutomatica: false,
      intervaloVencimiento: 1,
      diaVencimiento: 1,
      fechaOtorgado: moment().format("YYYY-MM-DD"),
      fechaInicio: moment().format("YYYY-MM-DD"),
      vencimientoRendicion: moment().format("YYYY-MM-DD"),
      entregoRendicion: null,
      numeroPrestamo: null
    },
    error: null
  },
  removeModal: {
    open: false,
    loading: false,
    id: null,
    error: null
  },
  saldos: []
};

const tipoPrestamoOptions = [
  {
    key: 0,
    text: "PRESTAMO",
    value: "PRESTAMO"
  },
  {
    key: 1,
    text: "SUBSIDIO",
    value: "SUBSIDIO"
  }
];

const intervaloVencimientoOptions = [
  {
    key: 0,
    text: "MENSUAL",
    value: 1
  },
  {
    key: 1,
    text: "BIMESTRAL",
    value: 2
  },
  {
    key: 2,
    text: "TRIMESTRAL",
    value: 3
  },
  {
    key: 3,
    text: "CUTRIMESTRAL",
    value: 4
  },
  {
    key: 4,
    text: "SEMESTRAL",
    value: 6
  },
  {
    key: 5,
    text: "ANUAL",
    value: 12
  }
];

class CoopPrestamosView extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
    this.PrestamoService = props.feathers.service("api/prestamos");
  }

  toggleUpserModal = (e, prestamo = null) => {
    let { prestamosUpsertModal } = this.state;

    if (prestamo) {
      this.setState(
        update(this.state, {
          prestamosUpsertModal: {
            $merge: {
              open: !prestamosUpsertModal.open,
              values: {
                id: prestamo.id,
                tipo: prestamo.tipo,
                concepto: prestamo.concepto,
                monto: prestamo.monto,
                nroCuotas: prestamo.nroCuotas,
                intervaloVencimiento: prestamo.intervaloVencimiento,
                diaVencimiento: prestamo.diaVencimiento,
                fechaOtorgado: moment(prestamo.fechaOtorgado).format(
                  "YYYY-MM-DD"
                ),
                numeroPrestamo: prestamo.numeroPrestamo,
                fechaInicio: moment(prestamo.fechaInicio).format("YYYY-MM-DD"),
                vencimientoRendicion: moment(
                  prestamo.vencimientoRendicion
                ).format("YYYY-MM-DD")
              }
            }
          }
        })
      );
    } else {
      this.setState(
        update(this.state, {
          prestamosUpsertModal: {
            $merge: {
              open: !prestamosUpsertModal.open
            }
          }
        })
      );
    }
  };

  dismissUpsert = e => {
    this.setState(
      update(this.state, {
        prestamosUpsertModal: {
          $set: {
            ...INITIAL_STATE.prestamosUpsertModal
          }
        }
      })
    );
    this.toggleUpserModal(e);
  };

  openRemoveModal = (e, PrestamoId) => {
    this.setState(
      update(this.state, {
        removeModal: {
          $merge: {
            open: true,
            id: PrestamoId
          }
        }
      })
    );
  };

  dismissRemove = e => {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  };

  removeRecord = e => {
    let {
      cooperativa: { id: CooperativaId }
    } = this.props;

    this.setState(
      update(this.state, {
        removeModal: {
          $merge: {
            loading: true,
            error: null
          }
        }
      })
    );

    this.PrestamoService.remove(this.state.removeModal.id)
      .then(response => {
        this.dismissRemove();
        this.findPrestamos();
        this.props.navigate(`/refresh/cooperativa/${CooperativaId}/prestamos`);
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            removeModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  inputHandler = (e, input) => {
    let name, value;

    if (input) {
      name = input.name;
      if (input.type === "checkbox") {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState(
      update(this.state, {
        prestamosUpsertModal: {
          values: {
            $merge: {
              [name]: value
            }
          }
        }
      })
    );
  };

  selectPrestamo = (e, prestamo) => {
    const {
      cooperativa: { id: CooperativaId }
    } = this.props;

    this.props.navigate(
      `/cooperativa/${CooperativaId}/prestamos/${prestamo.id}`
    );
  };

  calcultarSaldoCuota = (transacciones, plain = false) => {
    let saldo = transacciones.reduce(
      (prev, curr) => prev + numeral(curr.monto).value(),
      0
    );

    if (plain) {
      return numeral(saldo).value();
    } else if (saldo < 0) {
      return (
        <span style={{ color: "red" }}>
          <b>{numeral(saldo).format("(0,0.00)")}</b>
        </span>
      );
    } else {
      return numeral(saldo).format("(0,0.00)");
    }
  };

  calcSaldoRestante = () => {
    let { prestamos } = this.state;
    let saldos = [];

    prestamos.records.forEach(prestamo => {
      let saldo = prestamo.cuotas.reduce((prev, curr) => {
        return prev + this.calcultarSaldoCuota(curr.transacciones, true);
      }, 0);

      saldos.push({
        concepto: prestamo.concepto,
        saldo
      });
    });

    this.setState({
      saldos
    });
  };

  findPrestamos = () => {
    const {
      cooperativa: { id: CooperativaId }
    } = this.props;

    this.setState(
      update(this.state, {
        prestamos: {
          $merge: {
            loading: true,
            records: [],
            error: null
          }
        }
      })
    );

    this.PrestamoService.find({
      query: {
        CooperativaId
      }
    })
      .then(response => {
        this.setState(
          update(this.state, {
            prestamos: {
              $merge: {
                loading: false,
                records: response.records.map(a => ({
                  ...a,
                  balance: response.balances.find(b => b.PrestamoId == a.id)
                }))
              }
            }
          }),
          this.calcSaldoRestante
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            prestamos: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  submitUpsertPrestamo = e => {
    e.preventDefault();

    this.setState(
      update(this.state, {
        prestamosUpsertModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    let {
      cooperativa: { id: CooperativaId }
    } = this.props;
    let {
      prestamosUpsertModal: { values }
    } = this.state;

    if (values.id) {
      this.PrestamoService.patch(values.id, {
        ...values,
        monto: numeral(values.monto).value(),
        CooperativaId
      })
        .then(response => {
          this.setState(
            update(this.state, {
              prestamosUpsertModal: {
                $set: {
                  ...INITIAL_STATE.prestamosUpsertModal
                }
              }
            }),
            () => {
              this.findPrestamos();
              this.props.navigate(
                `/refresh/cooperativa/${CooperativaId}/prestamos/${response.id}`
              );
            }
          );
        })
        .catch(error => {
          this.setState(
            update(this.state, {
              prestamosUpsertModal: {
                $merge: {
                  loading: false,
                  error
                }
              }
            })
          );
        });
    } else {
      this.PrestamoService.create({
        ...values,
        monto: numeral(values.monto).value(),
        CooperativaId
      })
        .then(response => {
          this.setState(
            update(this.state, {
              prestamosUpsertModal: {
                $set: {
                  ...INITIAL_STATE.prestamosUpsertModal
                }
              }
            }),
            () => {
              this.findPrestamos();
              this.props.navigate(
                `/cooperativa/${CooperativaId}/prestamos/${response.id}`
              );
            }
          );
        })
        .catch(error => {
          this.setState(
            update(this.state, {
              prestamosUpsertModal: {
                $merge: {
                  loading: false,
                  error
                }
              }
            })
          );
        });
    }
  };

  componentDidMount() {
    this.findPrestamos();
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: path => {
        dispatch(push(path));
      }
    };
  }

  render() {
    let { cooperativa } = this.props;
    let { prestamos, prestamosUpsertModal, removeModal, saldos } = this.state;

    return (
      <Grid>
        <Grid.Column width={3}>
          <Header as="h4">
            <Button
              as={Icon}
              basic
              compact
              icon="plus"
              primary
              disabled={prestamos.loading}
              onClick={e => this.toggleUpserModal(e)}
            />
            <Header.Content>
              Prestamos
              <Header.Subheader>Lista de Prestamos</Header.Subheader>
            </Header.Content>
          </Header>
          <Menu fluid vertical tabular>
            {prestamos.loading && <Loader active inline />}
            <Menu.Item icon="money" header name="Prestamos" />
            {prestamos.records
              .filter(p => p.tipo === "PRESTAMO")
              .map((prestamo, index) => {
                let active = !!window.location.pathname.match(
                  new RegExp(`^/cooperativa/[0-9]*/prestamos/${prestamo.id}/?$`)
                );
                console.log("prestamo", prestamo);

                return (
                  <Menu.Item
                    key={index}
                    active={active}
                    onClick={e => this.selectPrestamo(e, prestamo)}>
                    {active && (
                      <Icon
                        name="trash"
                        color="red"
                        onClick={e => this.openRemoveModal(e, prestamo.id)}
                      />
                    )}
                    {active ? (
                      <b>{prestamo.concepto}</b>
                    ) : (
                      `${prestamo.concepto}`
                    )}
                    {prestamo.balance &&
                    parseInt(prestamo.balance.restante) >= 0 ? (
                      <i>Cancelado</i>
                    ) : null}
                    {active && (
                      <Menu.Menu>
                        <Menu.Item
                          as={"button"}
                          name="editar"
                          onClick={e => this.toggleUpserModal(e, prestamo)}
                        />
                      </Menu.Menu>
                    )}
                  </Menu.Item>
                );
              })}
            <Menu.Item icon="money" header name="Subsidios" />
            {prestamos.records
              .filter(p => p.tipo === "SUBSIDIO")
              .map((prestamo, index) => {
                let active = !!window.location.pathname.match(
                  new RegExp(`^/cooperativa/[0-9]*/prestamos/${prestamo.id}/?$`)
                );

                return (
                  <Menu.Item
                    key={index}
                    active={active}
                    onClick={e => this.selectPrestamo(e, prestamo)}>
                    {active && (
                      <Icon
                        name="trash"
                        color="red"
                        onClick={e => this.openRemoveModal(e, prestamo.id)}
                      />
                    )}
                    {active ? (
                      <b>{prestamo.concepto}</b>
                    ) : (
                      `${prestamo.concepto}`
                    )}
                    {active && (
                      <Menu.Menu>
                        <Menu.Item
                          as={"button"}
                          name="editar"
                          onClick={e => this.toggleUpserModal(e, prestamo)}
                        />
                      </Menu.Menu>
                    )}
                  </Menu.Item>
                );
              })}
          </Menu>
        </Grid.Column>
        <Grid.Column stretched width={13}>
          <Route
            exact
            path={`/cooperativa/:id/prestamos/:prestamo`}
            render={({ match }) => {
              return (
                <CoopPrestamosDetalleView
                  match={match}
                  feathers={this.props.feathers}
                  findPrestamos={this.findPrestamos}
                />
              );
            }}
          />
        </Grid.Column>
        <Modal
          dimmer="blurring"
          size="small"
          open={prestamosUpsertModal.open}
          onClose={this.dismissUpsert}>
          <Header icon="edit" content="Formulario de registro" />
          <Modal.Content>
            <Form
              onSubmit={this.submitUpsertPrestamo}
              loading={prestamosUpsertModal.loading}>
              <Form.Group>
                <Form.Input
                  name="numeroPrestamo"
                  label="Numero de Prestamo"
                  value={prestamosUpsertModal.values.numeroPrestamo}
                  onChange={this.inputHandler}
                  type="number"
                  width={3}
                />
                <Form.Select
                  name="tipo"
                  label="Prestamo/Subsidio"
                  value={prestamosUpsertModal.values.tipo}
                  onChange={this.inputHandler}
                  options={tipoPrestamoOptions}
                  width={5}
                />
                <Form.Input
                  name="fechaOtorgado"
                  label="Fecha Otorgado"
                  value={prestamosUpsertModal.values.fechaOtorgado}
                  onChange={this.inputHandler}
                  type="date"
                  width={4}
                />
                <Form.Input
                  name="vencimientoRendicion"
                  label="Vencimiento Rendicion"
                  value={prestamosUpsertModal.values.vencimientoRendicion}
                  onChange={this.inputHandler}
                  type="date"
                  width={4}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  name="concepto"
                  label="Concepto"
                  value={prestamosUpsertModal.values.concepto}
                  onChange={this.inputHandler}
                  width={7}
                />
                <Form.Input
                  name="monto"
                  label="Monto"
                  disabled={!!prestamosUpsertModal.values.id}
                  width={6}
                  children={
                    <MaskedInput
                      name="monto"
                      mask={numberMask}
                      value={prestamosUpsertModal.values.monto}
                      onChange={this.inputHandler}
                    />
                  }
                />
                <Form.Input
                  name="nroCuotas"
                  label="Cuotas"
                  disabled={!!prestamosUpsertModal.values.id}
                  value={prestamosUpsertModal.values.nroCuotas}
                  onChange={this.inputHandler}
                  type="number"
                  width={3}
                />
              </Form.Group>
              <Form.Group>
                <Form.Checkbox
                  name="generacionAutomatica"
                  label="Generacion Automatica de Cuotas"
                  disabled={!!prestamosUpsertModal.values.id}
                  checked={prestamosUpsertModal.values.generacionAutomatica}
                  onChange={this.inputHandler}
                />
              </Form.Group>
              <Form.Group>
                <Form.Select
                  name="intervaloVencimiento"
                  label="Intervalo de Vencimiento"
                  disabled={
                    !!prestamosUpsertModal.values.id ||
                    !prestamosUpsertModal.values.generacionAutomatica
                  }
                  value={prestamosUpsertModal.values.intervaloVencimiento}
                  onChange={this.inputHandler}
                  options={intervaloVencimientoOptions}
                  width={5}
                />
                <Form.Input
                  name="diaVencimiento"
                  label="Dia de Vencimiento"
                  disabled={
                    !!prestamosUpsertModal.values.id ||
                    !prestamosUpsertModal.values.generacionAutomatica
                  }
                  value={prestamosUpsertModal.values.diaVencimiento}
                  onChange={this.inputHandler}
                  type="number"
                  min={1}
                  max={25}
                  width={3}
                />
                <Form.Input
                  name="fechaInicio"
                  label="Primer Cuota"
                  disabled={
                    !!prestamosUpsertModal.values.id ||
                    !prestamosUpsertModal.values.generacionAutomatica
                  }
                  value={prestamosUpsertModal.values.fechaInicio}
                  onChange={this.inputHandler}
                  type="date"
                  width={4}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              disabled={prestamosUpsertModal.loading}
              basic
              negative
              icon="remove"
              content="Cancelar"
              onClick={this.dismissUpsert}
            />
            <Button
              disabled={prestamosUpsertModal.loading}
              primary
              icon="plus"
              content="Aceptar"
              onClick={this.submitUpsertPrestamo}
            />
          </Modal.Actions>
        </Modal>
        <Modal
          dimmer="blurring"
          basic
          size="small"
          open={removeModal.open}
          onClose={this.dismissRemove}>
          <Header icon="trash" content="Eliminar registro" />
          <Modal.Content>
            <p>Seguro desea eliminar este registro?</p>
            {removeModal.error && (
              <Message negative>
                <Message.Header>
                  Error! {removeModal.error.message}
                </Message.Header>
                <p>{removeModal.error.name}</p>
              </Message>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="red"
              inverted
              disabled={removeModal.loading}
              onClick={this.dismissRemove}>
              <Icon name="remove" /> No
            </Button>
            <Button
              color="green"
              inverted
              disabled={removeModal.loading}
              onClick={this.removeRecord}>
              <Icon name="checkmark" />{" "}
              {removeModal.loading ? "Procesando..." : "Si"}
            </Button>
          </Modal.Actions>
        </Modal>
      </Grid>
    );
  }
}

export default connect(
  CoopPrestamosView.mapStateToProps,
  CoopPrestamosView.mapDispatchToProps
)(CoopPrestamosView);

/*

<Grid.Column width={3}>
          <Header size="small">
            <Icon name="dollar" />
            <Header.Content>
              Saldo
              <Header.Subheader>
                Balance de prestamos
              </Header.Subheader>
            </Header.Content>
          </Header>
          <List divided relaxed>
            {
              saldos.filter(saldo => saldo.saldo !== 0).map((saldo, index) => (
                <List.Item key={index}>
                  <List.Content>
                    <List.Header>{saldo.concepto}</List.Header>
                    <List.Description>
                      <span style={{ color: 'red' }}><strong>{numeral(saldo.saldo).format('(0,0.00)')}</strong></span>
                    </List.Description>
                  </List.Content>
                </List.Item>
              ))
            }
          </List>
          <Statistic color="red" size="small">
            <Statistic.Label>Total</Statistic.Label>
            <Statistic.Value>
              {
                numeral(
                  saldos.filter(saldo => saldo.saldo !== 0).reduce((prev, curr) => {
                    return prev + curr.saldo;
                  }, 0)
                ).format('(0,0.00)')
              }
            </Statistic.Value>
          </Statistic>
        </Grid.Column>

*/



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopPrestamosView.js